import { render, staticRenderFns } from "./EditUserEventModal.vue?vue&type=template&id=13ab1b56&scoped=true&"
import script from "./EditUserEventModal.vue?vue&type=script&lang=js&"
export * from "./EditUserEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab1b56",
  null
  
)

export default component.exports